import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPreviewOffFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPreviewOffFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4f682bdfb8c1bc433b51ad3ae843d6d2daf50036', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'efc641cd6ae422c710d0f701ebd9d47ec7f74020', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fe5d3c770b526b934ecd15306ea5e3ccb7a48b1f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.515 3.146a.51.51 0 0 1 .717 0l3.48 3.48A8.1 8.1 0 0 1 10.886 6c3.32 0 5.86 1.83 7.82 4.71a.55.55 0 0 1 0 .58c-.884 1.336-1.912 2.441-3.086 3.244l3.233 3.233a.52.52 0 0 1 0 .727l-.359.359a.52.52 0 0 1-.727 0L3.147 4.233a.51.51 0 0 1 0-.718zm9.253 8.536q.117-.322.119-.682a2 2 0 0 0-2.682-1.88zm-9.682-.972c.632-.932 1.324-1.755 2.084-2.44l7.536 7.537a8.5 8.5 0 0 1-1.82.193c-3.31 0-5.88-1.81-7.8-4.71a.53.53 0 0 1 0-.58", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-preview-off-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-preview-off-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-preview-off-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPreviewOffFilled$1);
            }
            break;
    } });
}

const CosmosIconPreviewOffFilled = CosmosIconPreviewOffFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPreviewOffFilled, defineCustomElement };
